import { useEffect, useMemo, useState } from "react";

export default function useRowSelection({
    data = [],
    // rowKey = "user_id",
    rowKey = record => record?.user_id,
    value = [],              // ✅ external IDs
    maxSelection = 300,
    onLimitExceed,
    onChange
}) {
    const [selectedSet, setSelectedSet] = useState(new Set(value));

    /* 🔁 SYNC MANUAL → CHECKBOX */
    useEffect(() => {
        // setSelectedSet(new Set(value));
        setSelectedSet(new Set(value.map(String)));
    }, [JSON.stringify(value)]);

    const getRowId = row => {
        const id =
            typeof rowKey === "function"
                ? rowKey(row)
                : row?.[rowKey];

        return id != null ? String(id) : null;
    };

    // const visibleIds = useMemo(
    //     () => data.map(row => String(row[rowKey])),
    //     [data, rowKey]
    // );
    const visibleIds = useMemo(
        () => data.map(getRowId).filter(Boolean),
        [data]
    );

    const selectedCount = useMemo(
        () => visibleIds.filter(id => selectedSet.has(id)).length,
        [visibleIds, selectedSet]
    );

    const isAllSelected =
        visibleIds.length > 0 && selectedCount === visibleIds.length;

    const isIndeterminate =
        selectedCount > 0 && selectedCount < visibleIds.length;

    const canAddMore = (count = 1) =>
        selectedSet.size + count <= maxSelection;

    const toggleRow = id => {
        id = String(id);
        setSelectedSet(prev => {
            const next = new Set(prev);

            if (next.has(id)) {
                next.delete(id);
            } else {
                if (!canAddMore()) {
                    onLimitExceed?.(maxSelection);
                    return prev;
                }
                next.add(id);
            }

            onChange?.(Array.from(next));
            return next;
        });
    };

    const selectAllVisible = () => {
        setSelectedSet(prev => {
            const next = new Set(prev);
            const newIds = visibleIds.filter(id => !next.has(id));

            if (!canAddMore(newIds.length)) {
                onLimitExceed?.(maxSelection);
                return prev;
            }

            newIds.forEach(id => next.add(id));
            onChange?.(Array.from(next));
            return next;
        });
    };

    const clearAllVisible = () => {
        setSelectedSet(prev => {
            const next = new Set(prev);
            visibleIds.forEach(id => next.delete(id));
            onChange?.(Array.from(next));
            return next;
        });
    };

    const isChecked = id => selectedSet.has(String(id));

    return {
        selectedIds: Array.from(selectedSet),
        isChecked,
        isAllSelected,
        isIndeterminate,
        toggleRow,
        selectAllVisible,
        clearAllVisible
    };
}